export default __webpack_public_path__ + "static/media/xlsx.8ab3448e.svg";